module.exports = __webpack_public_path__ + "static/media/taj.4740f24a.png";